export const sanitizeGFALAmountInput = (value: string): string => {
  return value
    .replace(/[^\d.]/g, "")
    .replace(/(\..*)\./g, "$1");
};
